import React from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  size?: number;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, children, size = 4 }) => {
  return (
    <Grid
      container
      spacing={0}
      size={size}
      sx={{ backgroundColor: 'background.paper', border: '1px solid', borderColor: 'border.default', borderRadius: 1 }}
    >
      <Grid size={12} sx={{ borderBottom: '1px solid', borderColor: 'border.default', p: 1 }}>
        <Typography color="primary">{title}</Typography>
      </Grid>
      {children}
    </Grid>
  );
};

export default InfoCard;
